<template>
  <div>
    <ValidationObserver ref="form">
      <div class="grid">
        <div class="vx-row">
          <div class="vx-col w-full">
            <vx-input-group class="mb-2 mt-3">
              <ValidationProvider name="Nombre" rules="required" v-slot="{ errors }">
                <vs-input label-placeholder="Nombre" v-model="tableForm.name" class="w-full" />
                <p class="text-danger">{{ errors[0] }}</p>
              </ValidationProvider>
            </vx-input-group>
          </div>
          <div class="vx-col w-full">
            <vx-input-group class="mb-2 mt-3">
              <vs-checkbox v-model="tableForm.terrace">{{ $t('Suplemento') }}</vs-checkbox>
            </vx-input-group>
          </div>
          <div class="vx-col w-full text-right">
            <vs-button depressed color="success" type="border" class="mr-2" @click.prevent="handleSubmit">
              {{ $t('table.ActualizarMesa') }}
            </vs-button>
          </div>
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  props: {
    table: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      tableForm: {},
    };
  },
  computed: {
    ...mapGetters({
      language: 'getCurrentLanguage',
    }),
  },
  created() {
    this.tableForm = this.createTableForm(this.table);
  },
  methods: {
    ...mapActions({
      editTable: 'editTable',
    }),
    createTableForm(table) {
      return {
        id: table.id,
        name: table.name,
        restaurant_id: table.restaurant_id,
        terrace: table.terrace,
      };
    },
    handleSubmit() {
      this.$refs.form.validate().then((success) => {
        if (!success) {
          setTimeout(() => {
            let textAux = '';
            const errors = this.$refs.form.errors;
            Object.keys(errors).forEach((key) => {
              const error = errors[key];
              if (error.length) {
                error.forEach(function (text) {
                  textAux += `<p>${text}</p>`;
                });
              }
            });
            this.$store.commit('notifications', {
              title: 'Existen errores en el formulario.',
              color: 'danger',
              text: textAux,
            });
            this.$store.commit('showNotifications', true);
          }, 100);
          return;
        }

        this.submitted = true;

        const formData = this.createFormData();

        this.editTable({ id: this.tableForm.id, table: formData, language: this.language });

        // Wait until the models are updated in the UI
        this.$nextTick(() => {
          this.$refs.form.reset();
        });
      });
    },

    createFormData() {
      const data = new FormData();
      data.append('name', this.tableForm.name);
      if (this.tableForm.terrace) data.append('terrace', 1);
      else data.append('terrace', 0);
      data.append('restaurant_id', this.tableForm.restaurant_id);
      return data;
    },
  },
};
</script>
